import React from 'react';
import { withTranslation } from 'config/i18n';
import { useCookies } from 'react-cookie';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from 'components/shared/Link';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
// Material UI icons
import CloseIcon from '@material-ui/icons/Close';
import { Hidden } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: 0,
    padding: theme.spacing(2, 0, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 0, 2),
    },
    width: '100%',
    backgroundColor: 'rgba(17,17,17,0.96)',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    zIndex: 3,
  },
  close: {
    textAlign: 'right',
    "& [class*='MuiButtonBase-root']": {
      color: 'rgba(255, 255, 255, 0.75)',
    },
  },
  info: {
    height: '100%',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      padding: theme.spacing(0),
    },
    '& $title': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& $description': {
      color: 'rgba(255, 255, 255, 0.75)',
      display: 'inline-block',
      lineHeight: 1.3,
      margin: theme.spacing(1, 0),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0),
      },
      '& a': {
        color: theme.palette.primary.main,
        textTransform: 'uppercase !important',
        fontWeight: 500,
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  title: {},
  description: {},
  submit: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    "& [class*='MuiButtonBase-root']": {
      borderColor: theme.palette.primary.main,
      fontSize: '0.875rem',
      lineHeight: 1.3,
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0),
      },
      transition: theme.transitions.create(['color', 'background-color'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.short,
      }),
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    },
  },
}));

const Cookies = ({ t }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const [cookies, setCookie] = useCookies(['ac']);

  const handleClose = () => {
    setExpanded(false);
    const expiryTime = new Date();
    expiryTime.setFullYear(expiryTime.getFullYear() + 1);
    setCookie('ac', '1', {
      expires: expiryTime,
    });
  };

  React.useEffect(() => {
    if (cookies.ac != '1') {
      setExpanded(true);
      setTimeout(() => {
        handleClose();
      }, 30000);
    }
  }, []);

  const closeButton = (
    <div className={classes.close}>
      <IconButton onClick={handleClose} aria-label="Close">
        <CloseIcon />
      </IconButton>
    </div>
  );

  return (
    <>
      <Slide in={expanded} direction="up">
        <div className={classes.root}>
          <Container>
            <Grid container spacing={2}>
              <Grid item md={9} xs={12}>
                <div className={classes.info}>
                  <div className={classes.title}>
                    <Typography variant="subtitle2">
                      {t('layout:footer.site_use_cookies')}
                    </Typography>
                    <Hidden mdUp implementation="css">
                      {closeButton}
                    </Hidden>
                  </div>
                  <Typography variant="caption" className={classes.description}>
                    {t('layout:footer.cookies_privacy_policy')}
                    .&nbsp;
                    <Link
                      href="/privacy-policy"
                      color="primary"
                      target="_blank"
                    >
                      {t('layout:footer.er_privacy_policy')}
                    </Link>
                  </Typography>
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <Hidden smDown implementation="css">
                  {closeButton}
                </Hidden>
                <div className={classes.submit}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onClick={handleClose}
                    size="large"
                  >
                    {t('layout:footer.close_dont_show')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </Slide>
    </>
  );
};

export default withTranslation(['layout'])(Cookies);
